module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Test<br> hukommelsen","label":"Teori"},"en":{"title":"Test<br> your memory","label":"Theory"}}')
  delete Component.options._Ctor
}
